// Port of api/fuel/app/classes/insights/player/weight.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'

export default Segment.extend({
	name: 'weight',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	insight: false,
	detail: false,
	run: function() {
		var weights = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
		var playKeys = Object.keys(this._data.plays || {})

		for (var i = 0; i < playKeys.length; i++) {
			var play = this._data.plays[playKeys[i]]
			if (play.w <= 1.24) weights[0] += play.c
			else if (play.w <= 1.49) weights[1] += play.c
			else if (play.w <= 1.74) weights[2] += play.c
			else if (play.w <= 1.99) weights[3] += play.c
			else if (play.w <= 2.24) weights[4] += play.c
			else if (play.w <= 2.49) weights[5] += play.c
			else if (play.w <= 2.74) weights[6] += play.c
			else if (play.w <= 2.99) weights[7] += play.c
			else if (play.w <= 3.24) weights[8] += play.c
			else if (play.w <= 3.49) weights[9] += play.c
			else if (play.w <= 3.74) weights[10] += play.c
			else if (play.w <= 3.99) weights[11] += play.c
			else if (play.w <= 4.24) weights[12] += play.c
			else if (play.w <= 4.49) weights[13] += play.c
			else if (play.w <= 4.74) weights[14] += play.c
			else if (play.w <= 5) weights[15] += play.c
		}

		return {
			weight: weights
		}
	}
})
